import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import ItemModifications from '../ItemModifications';
import { CompleteBongQuery_venue_company_categories_items as Item } from '~Scenes/POS/Queries/__queries__';
import { LocalItem, LocalVariation } from '~Types';
import { useI18n, useSelector } from '~Hooks';
import { ItemCategoryMap } from '~Scenes/POS/categories';

interface Props {
  itemId: string;
  itemToRemove: string;
  allItems: Item[];
  prevSelected: {
    variations: LocalVariation[];
    removedVariations: LocalVariation[];
    upsales: LocalItem[];
  };
  onAddItem: (
    id: string,
    title: string,
    categoryId: string,
    options: {
      variations: LocalVariation[];
      removedVariations: LocalVariation[];
      message?: string | null;
      type?: string;
      count?: number;
      courseType?: any;
      isMessage?: boolean;
      parentId?: string;
    },
    price?: number,
    itemToRemove?: string,
  ) => { cartItemIds: string[] };
  itemToCategoryMap: ItemCategoryMap;
  closeModal: () => void;
}

const ItemModificationChange: FC<Props> = ({
  itemId,
  itemToRemove,
  allItems,
  onAddItem,
  prevSelected,
  itemToCategoryMap,
  closeModal,
}) => {
  const companyId = useSelector((state) => state.company);
  const matchingItem = allItems.find((item) => item.id == itemId);
  const { i18n } = useI18n();

  if (!matchingItem) return null;

  return (
    <Modal isShowing>
      <ItemModifications
        item={matchingItem}
        onClose={closeModal}
        addItem={({
          id = itemId,
          itemTitle = i18n(matchingItem.titleLang),
          variations,
          courseType,
          removedVariations,
          parentId,
        }) =>
          onAddItem(
            id!,
            itemTitle,
            itemToCategoryMap[id!]?.id ?? '',
            {
              variations,
              removedVariations,
              parentId,
              courseType: courseType ?? matchingItem.courseType,
            },
            undefined,
            itemToRemove,
          )
        }
        prevSelected={prevSelected}
      />
    </Modal>
  );
};

export default React.memo(ItemModificationChange);
